export const nav = {
    permission: 'ata.usage:ver',
    section: 'Minutes',
    title: 'Usage',
    icon: 'insights',
    route: '/usage',
    sequence: 13,
};

export default [
    {
        path: '/usage',
        name: 'usage',
        component: () => import('./pages/UsagePage.vue'),
        meta: { requiresAuth: true, permission: 'ata.usage:ver' },
    },
];
